import "./bootstrap";
import routes from "./routes";
import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { createPinia } from "pinia";
import { currentUser } from "@/core/users/session";
import { currentUserHasAnyRole } from "@/core/users/roles";
import App from "./App.vue";
const router = createRouter({
    history: createWebHistory(),
    routes: routes,
});
// Update document title on route change
router.beforeEach((to, from, next) => {
    document.title = (to.meta.title ? `${to.meta.title} | ` : "") + "Red On Track";
    const user = currentUser();
    if (user.region_code === "E300" && to.name === "objectives-report" && !window.__OBJECTIVES_REPORT_CAPTURE__) {
        next({ name: "results-report" });
        return;
    }
    const CASTILLA_ALLOWED_ROLES_ADVANCED = ["Gerente Distribucion", "Jefe de Distribucion", "Supervisor del Distribuidor"];
    if (user.region_code === "C200" && to.name === "advanced-report" && !currentUserHasAnyRole(CASTILLA_ALLOWED_ROLES_ADVANCED)) {
        next({ name: "home" });
        return;
    }
    next();
});
const app = createApp(App);
app.use(router);
app.use(createPinia());
app.mount("#app");
